import React, { useContext } from 'react'
import { AuthenticationContext } from 'app/Contexts/AuthenticationProvider'
import { routes } from 'app/routes'
import { NavLink as NavLinkRouter, useHistory } from 'react-router-dom'
import { useMutate } from 'restful-react'
import { endpoints } from 'app/api/endpoints'
import { Tooltip } from 'app/components/ui/Tooltip'
import userIcon from 'static/icons/user.svg'
import styled from 'styled-components'
import { Flex } from 'app/components/ui/Flex'
import { themeEstra } from 'app/styles/themeEstra'
export const TopMenuDropdown: React.FC = () => {
  const authCtx = useContext(AuthenticationContext)
  const { push } = useHistory()

  // LOGOUT
  const { mutate: doLogout /*, loading: isLoggingOut */ } = useMutate({
    verb: 'DELETE',
    path: endpoints.logout,
  })

  return authCtx && authCtx.actor ? (
    <div>
      <Tooltip
        shadow
        content={
          <ProfileImgWrapper>
            {' '}
            <img src={userIcon} alt='user' />
          </ProfileImgWrapper>
        }
        direction='bottom-left'
      >
        <LinkWrapper flexDirection='column'>
          <StyledNavLink
            to={routes.dashboard.makeUrl()}
            activeClassName='active'
            exact
          >
            Home
          </StyledNavLink>
          {/* USER */}
          <StyledNavLink to={routes.profile.makeUrl()} activeClassName='active'>
            Il tuo profilo
          </StyledNavLink>
          {/* LOGOUT */}
          <StyledNavLink
            as='a'
            href='#'
            onClick={(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
              e.preventDefault()
              doLogout('').then(() => {
                authCtx.executeLogout()
                push(routes.login.makeUrl())
              })
            }}
          >
            Esci dal sistema
          </StyledNavLink>
        </LinkWrapper>
      </Tooltip>
    </div>
  ) : null
}

const ProfileImgWrapper = styled.div`
  padding: 1rem 0;

  img {
    height: 24px;
    width: auto;
  }
  @media (min-width: ${themeEstra.bp.tablet}) {
    padding: 0;
    img {
      height: 38px;
    }
  }
  @media (min-width: 1000px) {
    img {
      height: 43px;
    }
  }
`

const LinkWrapper = styled(Flex)`
  padding: 0.5rem;
  color = ${({ theme }) => theme.color.primari.neroEstra};
`

const StyledNavLink = styled(NavLinkRouter)`
  color: ${({ theme }) => theme.color.primari.neroEstra};
  &.active {
    font-weight: 600;
  }
`
